type Listener = () => void;

interface CabinetState {
  expandedMenu: boolean;
  addFlowExpanded: boolean;
}

let state: CabinetState = {
  expandedMenu: false,
  addFlowExpanded: false,
};

let listeners: Listener[] = [];

const cabinetStore = {
  getSnapshot: () => state,

  subscribe: (listener: Listener) => {
    listeners = [...listeners, listener];
    return () => {
      listeners = listeners.filter((l) => l !== listener);
    };
  },

  setExpandedMenu: (value: boolean) => {
    state = { ...state, expandedMenu: value };
    emitChange();
  },

  setAddFlowExpanded: (value: boolean) => {
    state = { ...state, addFlowExpanded: value };
    emitChange();
  },

  toggleAddFlow: () => {
    state = { ...state, addFlowExpanded: !state.addFlowExpanded };
    emitChange();
  },
};

function emitChange() {
  for (const listener of listeners) {
    listener();
  }
}

export default cabinetStore;
